<template>
  <div>
    <div class="text-center">
      <div class="text-h3 text-uppercase">Proyectos</div>
      <v-btn
        v-show="networkOnLine"
        text
        color="primary"
        small
        class="caption text-center"
        @click="to('nuevoProyecto')"
      >
        Nuevo proyecto
      </v-btn>
    </div>
    <ProjectList></ProjectList>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProjectList from '@/components/admin/project/ProjectList'

export default {
  components: { ProjectList },
  computed: mapState('app', ['networkOnLine']),
  methods: {
    to(name, params) {
      // console.log('to -> name', name)
      this.$router.push({ name, params })
    }
  }
}
</script>
<style lang="scss" scoped></style>
